import React, { FC, PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';
import Slide from '@mui/material/Slide';
import Fade from '@mui/material/Fade';

import { useClickOutside } from '../../hooks/use-click-outside';
import StyledComponent, { ResponsiveStyle } from '../../../core/StyledComponent';

const StyledModal = styled.div(({}) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1050,
    display: 'flex',
    flexDirection: 'column',
}));

export interface ModalContainerProps extends ResponsiveStyle {
    isDark?: boolean;
    onClose: () => void;
    open: boolean;
    wrapper?: ResponsiveStyle;
    isDesktop?: boolean;
}

const ModalContainer: FC<PropsWithChildren<ModalContainerProps>> = ({
    children,
    open,
    xs,
    sm,
    md,
    lg,
    wrapper = {
        xs: {
            transform: 'translate(0, 0)',
            display: 'flex',
            alignItems: 'center',
            margin: 'auto',
        },
    },
    onClose,
    isDark,
    isDesktop,
}) => {
    const ref = useRef();

    useClickOutside(ref, () => {
        onClose();
    });

    return (
        <Fade
            in={open}
            timeout={{
                appear: 800,
                enter: 800,
                exit: 800,
            }}
            mountOnEnter
            unmountOnExit
        >
            <StyledModal
                style={{
                    background: isDark ? 'rgba(255, 255, 255, .5)' : 'rgba(0, 0, 0, .5)',
                    overflow: 'auto',
                }}
            >
                {isDesktop ? (
                    <StyledComponent {...wrapper}>
                        <StyledComponent ref={ref} xs={{ ...xs }} sm={sm} md={md} lg={lg}>
                            {children}
                        </StyledComponent>
                    </StyledComponent>
                ) : (
                    <Slide direction="up" timeout={500} in={open} mountOnEnter unmountOnExit>
                        <StyledComponent {...wrapper}>
                            <StyledComponent ref={ref} xs={{ ...xs }} sm={sm} md={md} lg={lg}>
                                {children}
                            </StyledComponent>
                        </StyledComponent>
                    </Slide>
                )}
            </StyledModal>
        </Fade>
    );
};

export default ModalContainer;
